/*
 * Public API Surface of timer
 */

export * from './lib/timer.module';
// export * from './lib/timer.directive';
